import { supportedLangs } from '@debbie/common/dist/lang/index.js'
import { c } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { LanguageInput } from '@debbie/iris/dist/components/LanguageInput.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

const LanguageSelector = () => {
  const currentLang = useSelector((s: RootState) => s.currentLang)

  return (
    <Wrapper>
      <LanguageInput
        language={currentLang}
        onChange={(lang) => c.lang.setLang(lang)}
        availableLanguages={supportedLangs}
      />
    </Wrapper>
  )
}

export default LanguageSelector

const Wrapper = styled.div`
  text-align: center;
  margin-top: 2em;
`
